module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-button-group"
  }, [(_vm.$slots.more) ? _c('div', [_c('el-popover', {
    ref: "popover",
    attrs: {
      "slot": "more",
      "trigger": "hover",
      "popper-class": "rtElPopover"
    },
    slot: "more"
  }, [_c('div', {
    staticClass: "rt-button-more",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._t("reference")], 2), _vm._v(" "), _c('div', {
    staticClass: "rt-button-group-popper-wrapper"
  }, [_vm._t("more")], 2)])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-701772af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/button/rtButtonSelect.vue
// module id = 2118
// module chunks = 228